import { dashboardClient } from '@/api'

export const gameQueryOptions = (companyId: string, gameId: string) => {
  return {
    queryKey: ['game', gameId],
    queryFn: () => dashboardClient.v1.getGame(companyId, gameId).then(r => r.data),
  }
}
